import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 2 }
const _hoisted_4 = {
  key: 0,
  style: {"text-align":"center"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "login_container" }, {
    title: _withCtx(() => [
      (_ctx.logoDark && _ctx.themeStore.getTheme === 'dark')
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.logoDark,
            alt: "logo"
          }, null, 8, _hoisted_1))
        : (_ctx.logoLight && _ctx.themeStore.getTheme === 'light')
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _ctx.logoLight,
              alt: "logo"
            }, null, 8, _hoisted_2))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('app.name')), 1))
    ]),
    content: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", { class: "pi pi-spin pi-spinner loader" }, null, -1)
          ]))]))
        : _renderSlot(_ctx.$slots, "default", { key: 1 }, undefined, true)
    ]),
    _: 3
  }))
}